import React from 'react';
import numeral from 'numeral';
import DNDHeader from 'components/lib/tables/dnd/DNDHeader';
import DnDNewBucket from 'components/lib/tables/dnd/DnDNewBucket';
import DnDRowContainer from 'components/lib/tables/dnd/DnDRowContainer';
import DnDDivider from 'components/lib/tables/dnd/DnDDivider';
import ConfirmationDialog from 'components/lib/modals/ConfirmationDialog';
import { clone } from 'utils/utils';
import { OT_COLORS } from 'utils/colorUtils';

import styles from 'styles/components/lib/tables/dnd/dndTable.css';
import PropTypes from 'prop-types';


/*
 TODO:
 2. verify swatch color is unique
 4. styles!
 5. touch events
*/
let DRAGGED_ROWS_TYPE = { keys: [], indexes: [] };
let ROW_ID_TYPE = { key: null, index: null };
let BUCKET_TALLY = { numTicketsSold: 0, totalRevenue: 0 };

export default class DNDTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bucketColors: [],
      draggedRows: DRAGGED_ROWS_TYPE,
      droppedRow: ROW_ID_TYPE,
      editingBucket: {},
      newBucket: this.props.bucketType,
      newBucketIndexes: [],
      parent: ROW_ID_TYPE,
      parentToDelete: null,
      rows: Object.values(this.props.data), // array of props.data
      showConfirmation: false,
      totals: {}
    }
  }

  componentWillMount() {
    this.sortRowsBy(this.props.sortValue, false, true);
  }

  componentWillReceiveProps(nProps) {
    if (nProps.data && nProps.buckets) {
      let childrenChange = this.checkChildrenChange(this.props.buckets, nProps.buckets);
      let currentRows = Object.values(this.props.data);
      let newRows = Object.values(nProps.data);
      if (!Object.deepEquals(currentRows, newRows)) {
        this.setState({
          rows: Object.values(nProps.data)
        }, () => {
          this.sortRowsBy(this.props.sortValue, false, true, nProps.buckets);
          this.getTotals();
        })
      } else if (!Object.deepEquals(this.props.buckets, nProps.buckets)) {
        this.sortRowsBy(this.props.sortValue, false, true, nProps.buckets, childrenChange);
        this.getTotals();
      }
    }
    let { parent, droppedRow } = this.state;
    let nBuckets = clone(nProps.buckets);
    if ( nBuckets && this.props.buckets && this.props.productionId === nProps.productionId) {
      let dropDownAdd = this.checkChildrenChange(this.props.buckets, nBuckets);
      let nLength = Object.keys(nBuckets).length;
      let pLength = Object.keys(this.props.buckets).length;
      if (parent && parent.key ) {
        let bucket = nBuckets[parent.key];
        if (!!droppedRow.key) {
          if (nLength > pLength) this.processNewBucket(bucket);
          else if (nLength === pLength) this.processDetails(bucket, parent.key, dropDownAdd) //dropDownAdd used here to see if children changed
        }
      } else if (dropDownAdd) { //dropDownAdd used for drop down menu adding because there is no parent
        let newParent = {};
        for (let i = 0; i < this.state.rows.length; i++) {
          if(this.state.rows[i].key && this.state.rows[i].key === dropDownAdd) {
            newParent = {key: dropDownAdd, index: i};
            break;
          }
        }
        let bucket = Object.assign({}, this.state.rows[newParent.index], {childrenKeys: nBuckets[dropDownAdd].childrenKeys})
        bucket = this.getChildren(bucket, bucket.childrenKeys)
        this.updateRows(bucket, newParent, true);
      } else { // no parent
        if ( !!droppedRow.key ) {
          this.processAddChildren(nBuckets[droppedRow.key]);
        } else if (nLength > pLength) {
          let newBucketKey;
          let propKeys = Object.keys(this.props.buckets)
          let newKeys = Object.keys(nProps.buckets)
          newKeys.forEach(key => {
            if(propKeys.indexOf(key) === -1){
              newBucketKey = key
            }
          })
          this.dropNewBucket(newBucketKey);
        }
      }
      this.getBucketColors();
    }
    if (nProps.errorBucketKey && nProps.errorBucketKey !== this.props.errorBucketKey) {
      let index;
      for (let i = 0; i < this.state.rows.length; i++){
        if (this.state.rows[i].key === nProps.errorBucketKey){
          index = i;
          break;
        }
      }
      this.setParent({key: nProps.errorBucketKey, index: index});
    } else if (this.props.errorBucketKey && nProps.errorBucketKey === null) {
      this.setParent();
    }

  }

  addDragRow = (row) => { //console.log('ADDDRAGROW', row);
    if (this.state.draggedRows.keys.indexOf(row.key) === -1){
      let keys = this.state.draggedRows.keys.slice(0);
      keys.push(row.key);
      let indexes = this.state.draggedRows.indexes.slice(0);
      indexes.push(row.index);
      return {keys: keys, indexes: indexes}
    }
  }

  addToBucket = (bucketKey, dropDown) => {  //console.log('ADDTOBUCKET');
    if (dropDown) {
      let droppedRow = {key: bucketKey, index: null};
      this.setState({ droppedRow })
    }
    let childrenKeys = this.props.buckets[bucketKey].childrenKeys.slice();
      for (let key of this.state.draggedRows.keys) {
        if (childrenKeys.indexOf(key) === -1) childrenKeys.push(key);
      }
    if (this.props.packages) this.props.onEditBucket(bucketKey, {childrenKeys: childrenKeys}, true);
    else this.props.onEditBucket(bucketKey, { childrenKeys: childrenKeys });
  }

  addToNewBucket = () => { //console.log('ADD TO NEW BUCKET');
    let bucket = clone(this.state.newBucket);
    let newBucket = this.getChildren(bucket, this.state.draggedRows.keys);
    let newBucketIndexes = this.getNewBucketIndexes();

    this.setState({ newBucket, newBucketIndexes });
  }

  checkChildrenChange = (oldBuckets, newBuckets) =>{
    let oldKeys = Object.keys(oldBuckets);
    let newKeys = Object.keys(newBuckets);
    // let skip = oldKeys.indexOf(null) === -1 || newKeys.indexOf(null) === -1;
    // Make sure buckets were deleted
    if(newKeys.length >= oldKeys.length) {
      for (let i = 0; i < oldKeys.length; i++) {
        let key = oldKeys[i]
        if(newBuckets[key] && newBuckets[key].childrenKeys.length !== oldBuckets[key].childrenKeys.length) return key;
      }
    }
    return false;
  }

  // Function built because of issue with recieving childrenKeys from props at different times and adding too many times
  checkCorrectTotals = (bucket) => {
    let qty = 0;
    let total = 0;
    for (let key in bucket.children) {
      qty += bucket.children[key].numTicketsSold
      total += bucket.children[key].totalRevenue
    }
    if (bucket.numTicketsSold !== qty) {
      return Object.assign({}, bucket, {numTicketsSold: qty, totalRevenue: total});
    } else return bucket;
  }

  clearData = (rows) => { //console.log('CLEARDATA');
    return rows.filter( row => Object.keys(row).length !== 0 );
  }

  closeDialog = () => {
    this.setState({
      showConfirmation: false
    })
  }

  createNewBucket = (droppedRow) => {  //console.log('CREATEBUCKET');
    let draggedRows = this.addDragRow(droppedRow);
    let newBucket = this.getNewBucket(draggedRows);
    this.setState({
      parent: {
        key: newBucket.key,
        index: droppedRow.index }}, () => {
      if (this.props.packages) this.props.onCreateNewBucket(newBucket, true);
      else this.props.onCreateNewBucket(newBucket);
    });
  }

  dropNewBucket = (bucketKey) => { //console.log('DROPNEW');
    let newBucket = Object.assign({}, this.state.newBucket, {key: bucketKey})
    this.setState({ newBucket }, () => {
      this.restoreNewBucket();
      // let rows = this.state.rows.slice();
      // let clearedRows = this.getClearedRows(rows, this.state.newBucketIndexes);
      // clearedRows.unshift(clone(this.state.newBucket));
      // rows.unshift(clone(this.state.newBucket));
      // this.restoreState( rows, true );
    })
  }

  getBucketColors = () => { //console.log('GETBUCKETCOLORS')
    let buckets  = Object.values(this.props.buckets);
    let bucketColors = [];
    for ( let b of buckets) {
      bucketColors.push(b.color);
    };
    this.setState({ bucketColors });
  }

  getBuckets = (newBuckets) => { //console.log('GETBUCKETS');
    let { data } = this.props;
    let rows = Object.values(data);
    let buckets = newBuckets ? newBuckets : clone(this.props.buckets);
    let bucketRows = [];
      for (let bucketKey in buckets) {
        let bucket = Object.assign( {}, buckets[bucketKey], { key: bucketKey, children: {}, ...BUCKET_TALLY });
        for (let key of bucket.childrenKeys) {
          if (Object.keys(data).indexOf(key) > -1) { // if it exists on data
            bucket = this.setChild( bucket, key );
            // removes children objects from rows
            let i = rows.indexOf(data[key]);
            rows.splice(i, 1);
          } // else remove key from childrenKeys?
        }
        bucketRows.push(bucket);
      }
    return {buckets: bucketRows, rows: rows};
  }

  getRowsForSorting = () => { //console.log("GETROWSFORSORTING")
    let { rows } = this.state;
    let bucketRows = [];
    let otherRows = [];
    for (let i = 0; i < rows.length; i++) {
      if(rows[i].children){
        bucketRows.push(rows[i])
      } else {
        otherRows.push(rows[i])
      }
    }
    return {buckets: bucketRows, rows: otherRows};
  }

  getChildren = (bucket , childrenKeys) => { //console.log('GETCHILDREN', bucket, childrenKeys);
    for (let key of childrenKeys) {
      bucket = this.setChild( bucket, key );
      if (bucket.childrenKeys.indexOf(key) === -1) bucket.childrenKeys.push(key);
    }

    return bucket;
  }

  getClearedRows = (rows = this.state.rows, indexes = this.state.draggedRows.indexes) => {
    for ( let i of indexes) rows[i] = {};
    let clearedRows = this.clearData(rows);

    return clearedRows;
  }

  getDragImage = (e, total) => {  //console.log('>>>> GET DRAG IMAGE >>> ');
    let elem = document.getElementById('dragIcon');

    e.dataTransfer.setDragImage(elem, 0, 0);
  }

  getNewBucket = (draggedRows = this.state.draggedRows) => {
    let newBucket = clone(this.props.bucketType);
        // newBucket.key = this.getNewId();
        newBucket.childrenKeys = draggedRows.keys;
    return newBucket;
  }

  getNewBucketIndexes = () => { //console.log('NB INDEXES');
      let { newBucketIndexes } = this.state;
      let { indexes } = this.state.draggedRows;
      return newBucketIndexes.concat(indexes);
  }

  getSortedRows = (rows, accessor) => { //console.log('GETSORTEDROWS', rows, accessor);
    if (accessor === 'numTicketsSold' || accessor === 'totalRevenue'){
      return rows.sort((a,b) => {
        return (a[accessor] > b[accessor]) ? 1
          : ((b[accessor] > a[accessor]) ? -1
              : 0
          );
      });
    } else {
      return rows.sort((a,b) => {
        if (a[accessor] && b[accessor]){
          return (a[accessor].toLowerCase() > b[accessor].toLowerCase()) ? 1
            : ((b[accessor].toLowerCase() > a[accessor].toLowerCase()) ? -1
                : 0
            );
        }
      });
    }
  }

  getTotals = (rows = this.state.rows) => {
    let quantity = 0;
    let totalRevenue = 0;
    rows.forEach((elem) => {
      if (elem.children) {
        quantity += elem.numTicketsSold
        totalRevenue += elem.totalRevenue
      }
    })
    this.setState({
      totals: {quantity: quantity, totalRevenue: totalRevenue}
    });
  }

  handleCancelNewBucket = () => { //console.log('CANCELNEWBUCKET');
    this.setState({ newBucket: this.props.bucketType, newBucketIndexes: [] }, () => {
      this.props.clearError();
    });
  }

  handleDeleteBucket = (e, parent = this.state.parent) => { //console.log('deleteBUCKET', e, parent);
    let rows = this.state.rows.slice(0);
    let childrenRows = Object.values(rows[parent.index].children)
        rows.splice(parent.index, 1, ...childrenRows);
    if (this.props.packages) this.props.onDeleteBucket(parent.id || parent.key, true);
    else this.props.onDeleteBucket(parent.id || parent.key);
    this.restoreState(rows);
  }

  handleDeleteChild = (e, deletedChild, isNewBucket) => { //console.log('DELETECHILD', deletedChild);
    let { childrenKeys } = this.state.editingBucket;

	if( childrenKeys.length  <=1 ) this.toggleDeleteDialog(this.state.parent);
	else {
		let draggedRows = clone(this.state.draggedRows);
		draggedRows.keys.push(deletedChild.key);
		draggedRows.indexes.push(deletedChild.index);
		let droppedRow = this.state.parent;
		this.setState({ draggedRows, droppedRow }, () => {
			if (isNewBucket) this.removeFromNewBucket(deletedChild)
			else this.removeFromBucket(deletedChild, droppedRow);
		});
    }
  }

  handleDragAdd = (e, draggedRow) => { //console.log('DRAG', draggedRow);
    if (this.state.draggedRows.keys.indexOf(draggedRow.key) === -1) {
      let draggedRows = this.addDragRow(draggedRow);
      this.setState({ draggedRows });
    }
    //set dataTrasfer
    this.getDragImage(e);
    if ( e.dataTransfer.setData ) e.dataTransfer.setData('text/html', null);
    e.dataTransfer.effectAllowed = 'move';
  }

  handleDragEnd = (e) => { // console.log('DRAGEEND!!!!!!!!!!');
    e.preventDefault();
    // this.setState({ draggedRows: DRAGGED_ROWS_TYPE });
  }

  handleDragOver = (e) => { // console.log("DRAGGING!");
    e.preventDefault(); //REQUIRED!!!
  }

  handleDrop = (e, droppedRow, hasChildren, isUnactive) => {
    //console.log('DROP', droppedRow, hasChildren, isUnactive );
    if(e.preventDefault) { e.preventDefault(); }
    if(e.stopPropagation) { e.stopPropagation(); }
    let { draggedRows, parent } = this.state;
    if ( (draggedRows && draggedRows.keys && draggedRows.keys.indexOf(droppedRow.key) > -1) ||
         (parent && parent.key &&  parent.key === droppedRow.key )) this.restoreDraggedRows();
    else {
      this.setState({ droppedRow }, () => {
        if (parent && !!parent.key) this.removeFromBucket();
        else {
          if ( hasChildren ) this.addToBucket(droppedRow.key);
          else {
            draggedRows = this.addDragRow(droppedRow);
            let droppedRowCleared = ROW_ID_TYPE;
            this.setState({ draggedRows, droppedRow: droppedRowCleared}, () => { this.setNewBucket() })
          }
        }
      });
    }
  }

  handleDropNewBucket = (e, parent) => { //console.log('HANDLEDROPNEWBUCKET', parent);
    e.preventDefault();
    if (parent.key) this.addToNewBucket();
    else this.setNewBucket();
  }

	// REQUIERED!
  handleDropOut = (e) => { // REQUIERED!
    this.restoreDraggedRows();
  }

  handleEditNewBucket = (details) => { //console.log('EDITNEWBUCLETDETAILS', details);
    let newBucket = clone(this.state.newBucket);
        newBucket = Object.assign({}, newBucket, details);

    this.setState({ newBucket });
  }

  handleSelectRow = (e, draggedRow) => { //console.log('handleSelectRow');
    let draggedRows;
      if (this.state.draggedRows.keys.indexOf(draggedRow.key) === -1) draggedRows = this.addDragRow(draggedRow);
      else draggedRows = this.removeDragRowFromState(draggedRow);

    this.setState({ draggedRows });
  }

  handleSubmitEditedBucket = (editedBucket, key) => {
    let { parent } = this.state;
    let bucket = this.state.editingBucket;
    if (editedBucket){
      bucket = Object.assign({}, this.state.editingBucket, editedBucket);
    }
    this.setState({
      editingBucket: {}
    }, () => {
      if (this.props.packages) this.props.onEditBucket(key ? key : parent.key, bucket, true);
      else this.props.onEditBucket(key ? key : parent.key, bucket);
      this.setParentNull();
    });
  }

  handleSubmitNewBucket = (e, newName = '') => { //console.log('HANDLESUBMIT');
    let { bucketsAccomulatives } = this.props;
    let newBucket = clone(this.state.newBucket);
    // prepares data to send to api
      delete newBucket.children
      for (let key of bucketsAccomulatives) {
        delete newBucket[key];
      }
    newBucket.name = newName;
    if (this.props.packages) this.props.onCreateNewBucket(newBucket, true);
    else this.props.onCreateNewBucket(newBucket);
    this.setState({ draggedRows: DRAGGED_ROWS_TYPE });
  }

  handleTouchEnter = (e,id) => { //console.log('TOUCHENTER');
    e.preventDefault();
  }

  processAddChildren = (bucket) => {  //console.log('PROCESSADD');
    let { draggedRows, droppedRow , rows } = this.state;
    let modifiedBucket  = Object.assign({}, rows[droppedRow.index], { childrenKeys: bucket.childrenKeys });
        modifiedBucket = this.getChildren(modifiedBucket, draggedRows.keys);

    this.updateRows(modifiedBucket);
  }

  processDetails = (modifiedBucket, key, childrenChange) => { //console.log('PROCESSDETAILS', modifiedBucket);
    let index;
    let rows = this.state.rows.slice();
    for (let i = 0; i < rows.length; i++) {
      if(rows[i].key && rows[i].key === key){
        rows[i] = Object.assign({}, rows[i], modifiedBucket )
      }
    }
        // rows[index] = Object.assign({}, rows[index], modifiedBucket );
    if(this.state.parent.key && childrenChange) this.restoreState(rows, null, this.state.parent);
    else this.restoreState(rows);
  }

  processNewBucket = (bucket) => { //console.log('PROCESSNEWBUCKET');
    let newBucket = Object.assign({}, bucket,  { children: {}, ...BUCKET_TALLY});
        newBucket = this.getChildren(newBucket, bucket.childrenKeys);
    this.updateRows(newBucket, this.state.parent);
  }

  processRemoveChildren = (bucket, childrenChange) => { //console.log('PROCESSREMOVEROW');
    let { draggedRows, parent, rows } = this.state;
    let { bucketsAccomulatives } = this.props;
    let modifiedBucket  = Object.assign({}, rows[parent.index], {childrenKeys: bucket.childrenKeys});
    let removedRows = [];
      for (let key of draggedRows.keys) {
        let child = modifiedBucket.children[key];
        removedRows.push(child);
        delete modifiedBucket.children[key];
        for (let key of bucketsAccomulatives) {
          modifiedBucket[key] -= child[key]
        }
      }

    this.restoreRows(modifiedBucket, removedRows, childrenChange);
  }

  removeDragRowFromState = (draggedRow) => { //console.log('REMOVEDRAGROW');
    let keys = this.state.draggedRows.keys.slice(0);
    let keyLocation = keys.indexOf(draggedRow.key);
        keys.splice(keyLocation, 1);
    let indexes = this.state.draggedRows.indexes.slice(0);
    let indexLocation = indexes.indexOf(draggedRow.index)
        indexes.splice(indexLocation, 1);

    return { keys: keys, indexes: indexes }
  }

  removeFromBucket = (deletedChild, parent = this.state) => { //console.log('REMOVEFROMBUCKET');
    let { editingBucket } = this.state;
    let bucketKeys = editingBucket.childrenKeys.slice();
    // let draggedKeys = this.state.draggedRows.keys.slice();

    let index = bucketKeys.indexOf(deletedChild.key);
    bucketKeys.splice(index, 1);

    // if(bucketKeys.length > 1){
    //   this.toggleDeleteDialog( parent);
    // } else {
      let newEditingBucket = Object.assign({}, this.state.editingBucket, {childrenKeys: bucketKeys})
      this.setState({
        editingBucket: newEditingBucket
      }, () => {
        this.processRemoveChildren(newEditingBucket, true);
      })
      // if (this.props.packages) this.props.onEditBucket(parent.key, {childrenKeys: bucketKeys}, true);
      // else this.props.onEditBucket(parent.key, {childrenKeys: bucketKeys});
    // }
  }

  removeFromNewBucket = (deletedChild) => {
    let stateBucket = Object.assign({}, this.state.newBucket);
    let bucketKeys = this.state.newBucket.childrenKeys.slice();
    let indexKeys = this.state.newBucketIndexes.slice();

    let keyIndex = bucketKeys.indexOf(deletedChild.key);
    bucketKeys.splice(keyIndex, 1);
    delete stateBucket.children[deletedChild.key];

    let newBucketIndex = indexKeys.indexOf(deletedChild.index)
    indexKeys.splice(newBucketIndex, 1);

    let newBucket = Object.assign({}, stateBucket, {childrenKeys: bucketKeys})
    let draggedRows = this.removeDragRowFromState(deletedChild);
    //console.log("NEWDRAGGEDROWS", draggedRows);
    this.setState({ newBucket, newBucketIndexes: indexKeys, draggedRows })
  }

  restoreDraggedRows = () => { //console.log('RESTOREDraggedrows', this.state.rows);
    this.restoreState(this.state.rows, null, this.state.parent);
  }

  restoreRows = (bucket, removedRows, childrenChange ) => { //console.log('RESTOREREMOVEDROWS');
    let { parent, droppedRow } = this.state;
    let rows = this.state.rows.slice(0);
        rows[parent.index] = bucket;
        // restore removed rows into dropped index
        rows.splice(droppedRow.index + 1, 0, ...removedRows);

    // check parent position on array
    if (droppedRow.index < parent.index) parent = this.updateParent(rows);
    if (this.state.parent.key && childrenChange) this.restoreState(rows, false, this.state.parent);
    else this.restoreState(rows);
  }

  restoreNewBucket = () => {
    this.setState({
      newBucket: this.props.bucketType,
      newBucketIndexes: []
    })
  }

  restoreStateFromEditing = () => {
    this.setState({
      ...this.state,
      rows: Object.values(this.props.data),
      editingBucket: {},
      parent: ROW_ID_TYPE,
      draggedRows: DRAGGED_ROWS_TYPE,
      droppedRow: ROW_ID_TYPE
    }, () => {
      this.props.clearError();
      this.sortRowsBy(this.props.sortValue, false, true);
      this.getTotals();
    })
  }

  restoreState = (rows = this.state.rows, isNew, parent = ROW_ID_TYPE, dropDown) => { //console.log('RESTORE', rows);
      if (isNew) dropDown = true;
      this.setState({
        ...this.state,
        parent: dropDown ? ROW_ID_TYPE : parent,
        rows,
        draggedRows: DRAGGED_ROWS_TYPE,
        droppedRow: ROW_ID_TYPE,
        newBucket: isNew ? this.props.bucketType : this.state.newBucket,
        newBucketIndexes: isNew ? [] : this.state.newBucketIndexes,
        showConfirmation: false,
        parentToDelete: null
      }, () =>{
        this.props.clearError();
        this.getTotals(rows)
      });
  }

  // restoreStateNewBucket = (rows = this.state.rows, newBucket = this.props.bucketType) => { //console.log('RESTORENEW', rows);
  //     this.setState({
  //       ...this.state, draggedRows: DRAGGED_ROWS_TYPE, newBucket,  parent: ROW_ID_TYPE, rows, newBucketIndexes: []
  //     }, () => {
  //       console.log("RESTORENEWWWWWWWSTATE, rows", this.state.rows);
  //       this.getTotals(rows);
  //     });
  // }

  setChild = (bucket, key) => { //console.log("SETCHILD", bucket, key);
    let { bucketsAccomulatives, data } = this.props;
    //gets child object from data
    if (data[key]){
      let childData = Object.assign({}, data[key]);
      if ( !bucket.children[key] || isNaN(bucket.children[key].numTicketsSold)) { // if there is no child object in bucket
        // adds tkt data to children obj...
        bucket.children[key] = childData;
        // updates accomulated data
        for (let accessor of bucketsAccomulatives) {
          bucket[accessor] += childData[accessor]
        }
      }
    }
    if (Object.keys(bucket.children).length > 0)
    for (let key in bucket.children) {
        if (bucket.childrenKeys.indexOf(key) === -1){
          delete bucket.children[key];
        }
    }
    return this.checkCorrectTotals(bucket);
  }

  setColors = () => { //console.log('SETTING COLORS');
    let buckets  = Object.values(this.props.buckets);
    let tagColors = Object.values(OT_COLORS);
    let bucketColors = [];
      for ( let b of buckets) {
        bucketColors.push(b.color);
        let i = tagColors.indexOf(b.color)
        if (i > -1 ) tagColors.splice(i, 1);
      };
    this.setState({ colors: { bucketColors, tagColors }});
  }

  setEditingBucket = () => {
    let { buckets } = this.props;
    let editingBucket = Object.assign({}, buckets[(this.state.parent.key)]);
    this.setState({ editingBucket });
  }

  setNewBucket = () => { //console.log('SET NEWBUCKET');
    let newBucket = Object.assign({}, this.getNewBucket(), {children: {}, ...BUCKET_TALLY });
        newBucket = this.getChildren(newBucket, this.state.draggedRows.keys);
    let newBucketIndexes = this.getNewBucketIndexes();
    this.setState({ newBucket, newBucketIndexes }, () =>{

    });
  }

  setParent = (parent) => { //console.log('setparent', parent);
    if (!parent) parent = ROW_ID_TYPE;
    this.setState({ parent: parent }, () => {
      if (parent.key !== null) this.setEditingBucket();
    });
  }

  setParentNull = () => {
    this.setState({ parent: ROW_ID_TYPE })
  }

  sortRowsBy = (accessor = this.props.accessor, inverse = false, initialSort, newBuckets, childrenChange) => {
    //console.log('SortRowsBy', accessor);
    let { buckets, rows } = initialSort ? this.getBuckets(newBuckets) : this.getRowsForSorting()
    let bucketAccessor = ( accessor === this.props.accessor) ? 'name' : accessor;
    if( typeof accessor !== 'string') accessor = 'displayName'
      // to sort buckets
      // let sortedBuckets = this.getSortedRows( Object.values(buckets), bucketAccessor);
      let sortedRows = this.getSortedRows(Object.values(rows), accessor);
      if (inverse) sortedRows.reverse();
    let ticketRows = []
    for (var i = 0; i < sortedRows.length; i++) {
      if (!sortedRows[i].children) ticketRows.push(sortedRows[i])
    }
    // REMOVED BELOW CODE -- UNCOMMENT IF ANYTHING IS BROKEN
    // if(this.state.parent.key && childrenChange) this.restoreState(buckets.concat(ticketRows), null, this.state.parent);
    //console.log("EDITINGBUCKET", Object.keys(this.state.editingBucket).length === 0);
    if (Object.keys(this.state.editingBucket).length === 0) this.restoreState(buckets.concat(ticketRows));
    else this.restoreState(buckets.concat(ticketRows))
  }

  toggleDeleteDialog = (e, parent) => {
    this.setState({
      parentToDelete: parent,
      showConfirmation: true
    })
  }

  updateParent = (rows) => {
    let { parent } = this.state;
    for ( let i = 0; i < rows.length; i++) {
      let row = rows[i];
      if (parent && row.key === parent.key) return Object.assign({}, parent, { index: i });
    }
  }

  updateRows = (newBucket, parent, dropDown) => { //console.log('UPDATEROWS');
    let rows = this.state.rows.slice(0); // clones rows
    let index = parent ? parent.index : (this.state.parent.index || this.state.droppedRow.index);
    rows[index] = Object.assign({}, rows[index], newBucket);
    let clearedRows = rows;
      if (this.state.draggedRows.indexes) clearedRows = this.getClearedRows(rows);
    this.restoreState(clearedRows, null, parent, dropDown);
  }

  render() {
    let { isActive, columns, buckets } = this.props;
    let { isTouchDevice } = this.context.media;
    let { bucketColors, draggedRows, newBucket, rows, parent, showConfirmation } = this.state;
    let bucketRows = [];
    let ticketRows = [];
    let draggedKeys = draggedRows.keys;
    rows.forEach((row, key) => {
        let element;
        if (Object.keys(row).length > 0) {
          let id = row.key || row.ticketTypeKey;
          let isUnactive = parent && parent.key !== null && parent.key !== id;
          let isDragged = newBucket && newBucket.childrenKeys && newBucket.childrenKeys.indexOf(id) > -1;
          let isSelectedGroup = draggedKeys.length > 1 && draggedKeys.indexOf(id) >= 0;


          element =   <li key={key} className={styles.listItem}>
                            <DnDRowContainer
                              ref={id}
                              key={id}
                              buckets={this.props.buckets}
                              bucketColors={bucketColors}
                              clearError={this.props.clearError}
                              columns={columns}
                              draggedRowsKeys={draggedRows.keys}
                              errorBucketKey={this.props.errorBucketKey}
                              errorMessage={this.props.errorMessage}
                              id={id}
                              index={key}
                              isSelectedGroup={isSelectedGroup}
                              isUnactive={isUnactive }
                              isDragged={ isDragged }
                              isEditing={this.state.parent && this.state.parent.key !== null}
                              isNewBucketCreation={this.state.newBucket.childrenKeys.length > 0}
                              onAddToBucket={this.addToBucket}
                              onAddToNewBucket={this.handleDropNewBucket}
                              onEditBucket={this.handleSubmitEditedBucket}
                              onCloseEdit={this.restoreStateFromEditing}
                              onClearDraggedRows={this.restoreDraggedRows}
                              onDelete={this.toggleDeleteDialog}
                              onDeleteChild={ this.handleDeleteChild }
                              onDragAdd={this.handleDragAdd}
                              onDrop={this.handleDrop}
                              onDragOver={this.handleDragOver}
                              onDragEnd={this.handleDragEnd}
                              onSelect={this.handleSelectRow}
                              onSetParent={this.setParent}
                              onSetParentNull={this.setParentNull}
                              onTouchEnd={this.handleDragEnd}
                              onTouchStart={this.handleDragAdd}
                              packages={this.props.packages}
                              row={row}
                              setEditingBucket={this.setEditingBucket}
                              selectedParent={parent}
                              isTouchDevice={isTouchDevice}/>
                          </li>
        } else {
          element =  <li key={key} className={styles.listItemEmpty} style={{minHeight: '0px', transition: 'all 0.3s ease-in-out'}}></li>;
        }
        if(row.children) {
          bucketRows.push(element);
        } else {
          ticketRows.push(element);
        }
    })

    return (
      <div className={this.props.packages ? styles.dndTablePackage : styles.dndTable}>
        <ConfirmationDialog
          showDialog={showConfirmation}
          text="Do you want to delete this group?"
          onCancel={this.closeDialog}
          onSubmit={(e) => { this.handleDeleteBucket(e, this.state.parentToDelete) }} />
        <DragIcon id={isActive ? "dragIcon" : "unactive"} qty={draggedRows.keys && draggedRows.keys.length} />
        <DnDNewBucket
          bucket={this.state.newBucket}
          columns={columns}
          draggedRowsKeys={draggedRows.keys}
          errorMessage={this.props.errorMessage}
          isEditing={this.state.parent && this.state.parent.key !== null}
          isNewBucketCreation={this.state.newBucket.childrenKeys.length > 0}
          onCancel={this.handleCancelNewBucket}
          onCloseEdit={this.restoreState}
          onDeleteChild={this.handleDeleteChild}
          onDragAdd={this.handleDragAdd}
          onDragOver={this.handleDragOver}
          onDrop={this.handleDropNewBucket}
          onEditNewBucket={this.handleEditNewBucket}
          onSetParent={this.setParent}
          onSubmit={this.handleSubmitNewBucket}
          packages={this.props.packages}
          selectedParent={parent}
          isTouchDevice={isTouchDevice} />
        { buckets && Object.keys(buckets).length > 0 &&
          [ <DnDDivider key="top-div"
                        groups={true}
                        header={this.props.packages ? "Package Groups" : "Ticket Groups"} />,
            <DNDHeader key={"header"}
                       columns={columns}
                       groups={true}
                       packages={this.props.packages}
                       isTouchDevice={isTouchDevice}/>,
            <ul key="grouplist"
                id="table"
                className={styles.bucketList} >
                { Object.keys(rows).length > 0 ? bucketRows
                  : <h1 style={{ color: 'gray', margin: '100px 0px', textAlign: 'center'}}>Loading ...</h1>
                }
            </ul>]}
        <DnDDivider key="bottom-div" groups={false} header={this.props.packages ? "Package Types" : "Ticket Types"} />
        <DNDHeader
          columns={columns}
          isEditing={this.state.parent && this.state.parent.key !== null}
          onClick={this.sortRowsBy}
          packages={this.props.packages}
          isTouchDevice={isTouchDevice}/>
        <ul id="table" className={styles.list} >
          { Object.keys(rows).length > 0 ? ticketRows
            : <h1 style={{color: 'gray', margin: '100px 0px', textAlign: 'center'}}>Loading ...</h1>
          }
        </ul>
      </div>
    );
  }
}

const DragIcon = ({id, qty, ...props}) => {
  return <div id={id} style={iconStyle}>{qty}</div>;
}




// class DragIcon extends React.Component {
//   render()  { //console.log('DRAGICON', qty);
//     let { qty } = this.props;
//     return  <div ref="dragIcon" id="dragIcon" style={iconStyle}>{qty}</div>;
// }}

let iconStyle = {
  position: 'absolute',
  top: '-10000vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  border: '2px solid #fff',
  backgroundColor: 'red',
  color: 'white',
  fontWeight: '600',
  fontSize: '16px',
  boxShadow: '0 0 9px 0 rgba(0,0,0,.3)'
}

DNDTable.contextTypes = {
	media: PropTypes.object
};

// ConsumerActionCreator.resetPassword(trimmedData).then(()=>{
//   if (!this.state.forgotPasswordEmailSent) {
//     this.setState({
//       forgotPasswordEmailSent: true,
//       forgotPasswordStatus: null,
//       isLoading: false
//     });
//   } else {
//     this.handleBackClick();
//   }
// },(error)=>{
//   this.setState({
//     forgotPasswordStatus: error.data.message,
//     isLoading: false
//   });
// });



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DNDTable.js